/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitworking2Inputs */

const en_coverfitworking2 = /** @type {(inputs: Coverfitworking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjusting…`)
};

const de_coverfitworking2 = /** @type {(inputs: Coverfitworking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird angepasst…`)
};

/**
* | output |
* | --- |
* | "Adjusting…" |
*
* @param {Coverfitworking2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitworking2 = /** @type {((inputs?: Coverfitworking2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitworking2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitworking2(inputs)
	return de_coverfitworking2(inputs)
});
export { coverfitworking2 as "coverFitWorking" }